export default __webpack_public_path__ + "932b59b1ea1557ea9514730c268d85af.jpg";